module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"es":{"list":[{"txt":["Logo Pay","RGBA (png, jpg)","CMYK (tiff)"],"btn":"DESCARGAR"},{"txt":["Logo Pay","fondo blanco RGBA","(png, jpg) CMYK (tiff)"],"btn":"DESCARGAR"},{"txt":["Popular Payments","Logos Tarjetas"],"btn":"DESCARGAR"}]}}')
  delete Component.options._Ctor
}
